import { opacity } from '../../utils';

const statusDefaults = {
  borderRadius: '2px',
  fontSize: '13px',
  fontStyle: 'italic',
  lineHeight: '15px',
};

const primary = ({ theme }) => ({
  color: theme.colors.gray[900],
  background: theme.colors.gray[400],
  borderRadius: '2px',
  height: '20px',
  lineHeight: '20px',
});

const secondary = ({ theme }) => ({
  color: theme.colors.gray[800],
  border: `1px solid ${theme.colors.gray[800]}`,
  background: theme.colors.gray[0],
  ...statusDefaults,
  fontStyle: 'regular',
});

const code = ({ theme }) => ({
  color: theme.colors.royalBlue[1000],
  background: theme.colors.gray[300],
  borderRadius: '2px',
  height: '16px',
  fontFamily: theme.fonts.code,
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'normal',
});

const statusTypes = theme => ({
  success: {
    color: theme.colors.semantic.success,
    backgroundColor: `1px solid ${theme.colors.semantic.success}`,
  },
  danger: {
    color: theme.colors.semantic.danger,
    backgroundColor: `1px solid ${theme.colors.semantic.danger}`,
  },
  warning: {
    color: theme.colors.semantic.warning,
    backgroundColor: `1px solid ${theme.colors.semantic.warning}`,
  },
  info: {
    color: theme.colors.semantic.info,
    backgroundColor: `1px solid ${opacity(theme.colors.gray[800], 40)}`,
  },
});

const status = ({ theme, status: statusType }) => {
  const typeParams = statusTypes(theme)[statusType];

  return {
    color: typeParams.color,
    border: typeParams.backgroundColor,
    ...statusDefaults,
  };
};

const beta = ({ theme }) => ({
  background: opacity(theme.colors.orange[500], 40),
  borderRadius: '2px',
  margin: '10px',
  fontFamily: theme.fonts.base,
  fontSize: theme.sizes.text.small,
  fontStyle: 'italic',
  fontWeight: 'bold',
  lineHeight: '13px',
  padding: '0 7px 0 7px',
});

interface ITagVariants {
  primary: any;
  secondary: any;
  success: any;
  danger: any;
  info: any;
  warning: any;
  beta: any;
  code: any;
}

export const tagVariants: ITagVariants = {
  primary,
  secondary,
  success: ({ theme }) => status({ theme, status: 'success' }),
  danger: ({ theme }) => status({ theme, status: 'danger' }),
  info: ({ theme }) => status({ theme, status: 'info' }),
  warning: ({ theme }) => status({ theme, status: 'warning' }),
  beta,
  code,
};
